module.exports = __webpack_public_path__ + "static/media/vinyl.26ca1a92.webp";